import React from "react"
import styled, { css } from 'styled-components'
import { Title, Item } from '../../../shared/Section'
import { Date, Week } from '../../../shared/Date'

const Wrapper = styled.div`
`

const Block = styled.span`
  span {
    display: inline-block;
  }
`

const BlockSpan = styled.span`
  display: inline-block;
`

const DateWrapper = styled.div`
  padding: 2.4rem 0 1.6rem;
`

const Header = styled.h3`
  ${({ theme: { breakpoints }}) => css`
    font-size: 1.8rem;
    @media (min-width: ${breakpoints.md}px) {
      font-size: 2.2rem;
    }
  `}
`

const Note = styled.div`
`

const Entrance = styled.div`
  padding-top: 2.4rem;
  font-size: 1.6rem;
  font-weight: 700;
`

const Info = () => {
  return (
    <>
      <Title>Info</Title>
      <Item>
        <Wrapper>
          <Header>
            <Block>
              <span>多摩美術大学</span> <span>情報デザイン学科</span> <span>情報デザインコース</span>
            </Block> 
            <Block>
              <span>卒業研究制作展 2021</span> <span>「そして、」</span>
            </Block>
          </Header>
          <DateWrapper>
            <Date>2021.3.5<Week>Fri</Week> - 3.7<Week>Sun</Week> <BlockSpan>11:00 - 19:00</BlockSpan></Date>
          </DateWrapper>
          <Note>
            <p>※最終日は17:00閉場</p>
            <p>※最終入場は閉場の30分前まで</p>
            <Entrance>
              <p>入場無料</p>
            </Entrance>
          </Note>
        </Wrapper>
      </Item>
    </>
  )
}

export default Info